import Vue from 'vue'
import Vuex from 'vuex'
// import { vuexfireMutations } from 'vuexfire'

import logging from './modules/logging'
import paymentValidations from './modules/paymentValidations'
import productAvailable from './modules/productAvailable'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    logging,
    paymentValidations,
    productAvailable
  },
  // mutations: vuexfireMutations
})

console.log('store/index:', store)

export default store
